import { createStore } from '@zen/common-app-parts';
import useDexDbUpdatesStore from './modules/useDexDbUpdatesStore';

const { Provider, useStore } = createStore({
  useStoreHook: useDexDbUpdatesStore,
  contextDisplayName: 'DexDbUpdatesStoreContext',
});

export default {
  /**
   * @type {DexDbUpdatesStoreProvider}
   */
  Provider,
  useStore,
};

/**
 * @typedef {({dbClient: Object, storage: Object, config: Object}) => void} DexDbUpdatesStoreProvider
 */
